var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.971,
    height: 13.971,
    viewBox: "0 0 13.971 13.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M12.895,8.2l-1.1-1.1L4.555,14.346v1.1h1.1Zm1.1-1.1,1.1-1.1-1.1-1.1-1.1,1.1ZM6.3,17H3V13.7L13.445,3.257a.777.777,0,0,1,1.1,0l2.2,2.2a.777.777,0,0,1,0,1.1L6.3,17Z",
    transform: "translate(-3 -3.029)",
    fill: "#acb0be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.81d47196e595de4d024a7968000fcfd9.svg";
export { ForwardRef as ReactComponent };